import { FormHandle } from '@/hooks/use-form-handle.hook';
import { FC } from 'react';
import InputControl from '@/components/form/input-control';
import { isWriteMode, ViewMode } from '@/lib/helpers';
import { PrivateModelModel } from '@/lib/models/private-model/private-model.model';

interface Props {
  formHandle: FormHandle<PrivateModelModel>;
  mode: ViewMode;
}

const VertexPrivateModel: FC<Props> = ({ formHandle, mode }) => {
  const inWriteMode = isWriteMode(mode);

  if (!inWriteMode) {
    return null;
  }

  return (
    <InputControl
      name="config.region"
      formHandle={formHandle}
      type="vertex-region-select"
      required
    />
  );
};

export default VertexPrivateModel;
